module.exports = __webpack_public_path__ + "static/media/img25.ca4dd283.jpg";